import {
   ListItemIcon,
   ListItemText,
   ListItem,
   List,
   CardContent,
   Card,
   Grid,
   Typography,
   Box,
   Button,
   AlertTitle,
   Alert,
} from '@mui/material';
import AuthLayout from './AuthLayout';
import { useState } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import CheckIcon from '@mui/icons-material/Check';
import { useSearchParams } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const PublicSubscription = () => {
   const [accountType, setAccountType] = useState<'personal' | 'organization'>('personal');
   const [searchParams] = useSearchParams();
   const userId = searchParams.get('userId');
   const email = searchParams.get('email');
   const returnUrl_path = searchParams.get('returnUrl_path');
   const [error, setError] = useState<string | null>(null);
   const { currentUser } = useUser();
   const navigate = useNavigate();

   const handleCreateSubscription = async (lookupKey: string | undefined) => {
      try {
         const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/create-subscription-checkout-session`,
            {
               method: 'POST',
               body: JSON.stringify({
                  lookupKey,
                  userId: userId || currentUser?.uid,
                  email: email || currentUser?.email,
                  returnUrl_path: returnUrl_path
                     ? `${window.location.origin}${decodeURIComponent(returnUrl_path)}`
                     : '',
               }),
               headers: {
                  'Content-Type': 'application/json',
               },
            }
         );

         const data = await response.json();

         if (response.status == 400) {
            setError(data.message);
            return;
         }

         if (data.url) {
            window.location.href = data.url;
         } else {
            setError('Subscription creation failed');
         }
      } catch (error) {
         setError(error instanceof Error ? error.message : 'An unknown error occurred');
      } finally {
         setTimeout(() => {
            setError(null);
         }, 5000);
      }
   };
   return (
      <AuthLayout>
         <Grid
            // maxWidth={false}
            container
            spacing={3}
            sx={{ margin: '0!important', width: '100%' }}
         >
            <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
               {error && (
                  <Alert severity='error' sx={{ mb: 2 }}>
                     <AlertTitle>Error</AlertTitle>
                     {error}
                  </Alert>
               )}
               <Button sx={{ mb: 2 }} onClick={() => window.history.back()}>
                  <ArrowBack />
                  Back
               </Button>
            </Grid>
            <Grid item xs={12} md={6} sx={{ mx: 'auto' }}>
               <Card
                  sx={{
                     margin: '0!important',
                     height: '100%',
                     cursor: 'pointer',
                     border: accountType === 'personal' ? 2 : 1,
                     borderColor: accountType === 'personal' ? 'primary.main' : 'divider',
                     transition: 'all 0.2s',
                     '&:hover': { boxShadow: 4 },
                  }}
                  onClick={() => setAccountType('personal')}
               >
                  <CardContent sx={{ textAlign: 'center', p: 3, pb: 6 }}>
                     <PersonIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />

                     <Typography variant='h6' gutterBottom>
                        Personal Account
                     </Typography>

                     <Typography
                        variant='body2'
                        color='text.secondary'
                        paragraph
                        sx={{ mb: 2, minHeight: 60 }}
                     >
                        For individual travelers who want to plan trips and share experiences with
                        friends and family.
                     </Typography>

                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'baseline',
                           justifyContent: 'center',
                           mb: 2,
                        }}
                     >
                        <Typography variant='h4' fontWeight='bold' color='primary'>
                           $35
                        </Typography>
                        <Typography variant='subtitle1' color='text.secondary' sx={{ ml: 1 }}>
                           per year
                        </Typography>
                     </Box>

                     <List sx={{ textAlign: 'left' }}>
                        <ListItem disablePadding sx={{ mb: 1 }}>
                           <ListItemIcon sx={{ minWidth: 36 }}>
                              <CheckIcon color='primary' fontSize='small' />
                           </ListItemIcon>
                           <ListItemText primary='Plan trips and create events' />
                        </ListItem>
                        <ListItem disablePadding sx={{ mb: 1 }}>
                           <ListItemIcon sx={{ minWidth: 36 }}>
                              <CheckIcon color='primary' fontSize='small' />
                           </ListItemIcon>
                           <ListItemText primary='Share photos and memories' />
                        </ListItem>
                        <ListItem disablePadding sx={{ mb: 1 }}>
                           <ListItemIcon sx={{ minWidth: 36 }}>
                              <CheckIcon color='primary' fontSize='small' />
                           </ListItemIcon>
                           <ListItemText primary='Collaborate with friends and family' />
                        </ListItem>
                        <ListItem disablePadding>
                           <ListItemIcon sx={{ minWidth: 36 }}>
                              <CheckIcon color='primary' fontSize='small' />
                           </ListItemIcon>
                           <ListItemText primary='Access to all basic features' />
                        </ListItem>
                     </List>
                     <Button
                        onClick={() =>
                           handleCreateSubscription(
                              process.env.REACT_APP_STANDARD_PERSONAL_YEARLY_LOOKUP_KEY
                           )
                        }
                        variant='contained'
                        color='primary'
                        sx={{ mt: 2 }}
                     >
                        Subscribe
                     </Button>
                  </CardContent>
               </Card>
            </Grid>

            {/* <Grid item xs={12} md={6}>
               <Card
                  sx={{
                     height: '100%',
                     cursor: 'default',
                     // cursor: 'pointer',
                     // border: accountType === 'organization' ? 2 : 1,
                     borderColor: 'divider',
                     border: '1px solid',
                     // borderColor: accountType === 'organization' ? 'primary.main' : 'divider',
                     transition: 'all 0.2s',
                     // '&:hover': { boxShadow: 4 },
                  }}
                  onClick={() => setAccountType('organization')}
               >
                  <CardContent sx={{ textAlign: 'center', p: 3, pb: 6 }}>
                     <PeopleIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />

                     <Typography variant='h6' gutterBottom>
                        Organization Account
                     </Typography>

                     <Typography
                        variant='body2'
                        color='text.secondary'
                        paragraph
                        sx={{ mb: 2, minHeight: 60 }}
                     >
                        For businesses, tour operators, and organizations who want to create and
                        monetize events with advanced management tools.
                     </Typography>

                     <Box
                        sx={{
                           display: 'flex',
                           alignItems: 'baseline',
                           justifyContent: 'center',
                           mb: 2,
                        }}
                     >
                        <Typography variant='h4' fontWeight='bold' color='primary'>
                           $50
                        </Typography>
                        <Typography variant='subtitle1' color='text.secondary' sx={{ ml: 1 }}>
                           per year
                        </Typography>
                     </Box>

                     <List sx={{ textAlign: 'left' }}>
                        <ListItem disablePadding sx={{ mb: 1 }}>
                           <ListItemIcon sx={{ minWidth: 36 }}>
                              <CheckIcon color='primary' fontSize='small' />
                           </ListItemIcon>
                           <ListItemText primary='Create public events' />
                        </ListItem>
                        <ListItem disablePadding sx={{ mb: 1 }}>
                           <ListItemIcon sx={{ minWidth: 36 }}>
                              <CheckIcon color='primary' fontSize='small' />
                           </ListItemIcon>
                           <ListItemText primary='Monetize your events' />
                        </ListItem>
                        <ListItem disablePadding sx={{ mb: 1 }}>
                           <ListItemIcon sx={{ minWidth: 36 }}>
                              <CheckIcon color='primary' fontSize='small' />
                           </ListItemIcon>
                           <ListItemText primary='Business analytics' />
                        </ListItem>
                        <ListItem disablePadding sx={{ mb: 1 }}>
                           <ListItemIcon sx={{ minWidth: 36 }}>
                              <CheckIcon color='primary' fontSize='small' />
                           </ListItemIcon>
                           <ListItemText primary='Aggregate attendee photos' />
                        </ListItem>
                        <ListItem disablePadding sx={{ mb: 1 }}>
                           <ListItemIcon sx={{ minWidth: 36 }}>
                              <CheckIcon color='primary' fontSize='small' />
                           </ListItemIcon>
                           <ListItemText primary='Network communication settings' />
                        </ListItem>
                        <ListItem disablePadding>
                           <ListItemIcon sx={{ minWidth: 36 }}>
                              <CheckIcon color='primary' fontSize='small' />
                           </ListItemIcon>
                           <ListItemText primary='Priority business support' />
                        </ListItem>
                     </List>
                     <Button
                        disabled={true}
                        color='secondary'
                        onClick={() =>
                           handleCreateSubscription(
                              process.env.REACT_APP_STANDARD_ORGANIZATION_YEARLY_LOOKUP_KEY
                           )
                        }
                        variant='contained'
                        // color='primary'
                        sx={{ mt: 2 }}
                     >
                        Subscribe
                     </Button>
                  </CardContent>
               </Card>
            </Grid> */}
         </Grid>
      </AuthLayout>
   );
};

export default PublicSubscription;
